import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46314e10&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=46314e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46314e10",
  null
  
)

export default component.exports